import api from '../api'

export function downloadManual(chargePointId: string): Promise<void> {
    return api
        .get({
            path: `/chargepoints/${chargePointId}/manual`,
            parseResponse: (r) => r.arrayBuffer(),
        })
        .then((response) => {
            createManual(chargePointId, response)
        })
}

export const createManual = (chargePointId: string, data: Blob) => {
    const file = new Blob([data], { type: 'application/txt' })
    const anchor = Object.assign(document.createElement('a'), {
        href: URL.createObjectURL(file),
        target: '_blank',
        download: `Configuration_${chargePointId}.txt`,
        style: 'display: none',
    })
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
}
